/** "25 oct, 9:58 a. m.": fecha corta con hora am/pm en la hora local del navegador. */
export const cuando = (iso: string | null | undefined): string => {
	if (!iso) return "";
	const d = new Date(iso);
	return isNaN(d.getTime()) ? iso : d.toLocaleString("es", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true });
};
